import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import {
  selectMainDataForModalUsis,
  selectUsisData,
  selectUsisModalStep,
  selectIsModalOpened,
  selectCommonModalsData,
  selectIsWaitingRequest,
  selectRedirectToEsiaUrl,
  selectIsModalConfirmDeactivateOpened,
  selectModalVariant,
  selectIsCommonModalOpened,
  selectUsisCommonModalStep,
} from '../../selectors';

import { ESIA_USIS_MODAL_STEPS } from '../../constants';
import { MainStep } from './components/MainStep';
import { CommonModal } from '../../../../../../components/Popups/CommonModal';
import { useModalContainerInit } from './hook';

const ModalEsiaContainer = ({
  modalData,
  step,
  commonStep,
  isModalOpened,
  commonModalsData,
  isWaitingRequest,
  redirectToEsiaUrl,
  isModalConfirmDeactivateOpened,
  modalVariant,
  isCommonModalOpened,
}) => {
  if (!step && !commonStep) return null;

  const { mainInfoData, commonData, confirmDeactivateModalData, mainAdditionalModal } = useModalContainerInit({
    modalData,
    step,
    commonStep,
    commonModalsData,
    redirectToEsiaUrl,
    isModalConfirmDeactivateOpened,
    isModalOpened,
    isCommonModalOpened,
    modalVariant,
  }) || {};

  const {
    data,
    handleOnCloseCommonModal,
    handlersBtn,
    isLoading,
  } = commonData || {};

  const {
    handlersCMBtn,
    dataCM,
  } = confirmDeactivateModalData || {};

  const {
    dataMainAdditional,
    handleOnCloseModal,
    handlersMainBtn: handlersBtnMainAdditional,
  } = mainAdditionalModal;

  if (step === ESIA_USIS_MODAL_STEPS.MAIN && isModalOpened) {
    return (
      <MainStep data={{ ...mainInfoData, isWaitingRequest }} isModalOpen={isModalOpened} />
    );
  }

  return (
    <>
      {isModalOpened && (
        /* main additional modal */
        <CommonModal
          isOpen={isModalOpened}
          data={dataMainAdditional}
          onClose={handleOnCloseModal}
          onConfirm={handlersBtnMainAdditional?.main}
          onAdditionalConfirm={handlersBtnMainAdditional?.additional}
        />
      )}

      {isCommonModalOpened && (
        <CommonModal
          isOpen={isCommonModalOpened}
          data={data}
          onClose={handleOnCloseCommonModal}
          onConfirm={handlersBtn?.main}
          onAdditionalConfirm={handlersBtn?.additional}
        />
      )}

      {isModalConfirmDeactivateOpened && (
        <CommonModal
          size="s"
          isOpen={isModalConfirmDeactivateOpened}
          data={dataCM}
          onClose={handlersCMBtn?.main}
          onConfirm={handlersCMBtn?.main}
          onAdditionalConfirm={handlersCMBtn?.additional}
          isCloseButtonVisible={false}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  modalData: selectMainDataForModalUsis(state),
  step: selectUsisModalStep(state),
  commonStep: selectUsisCommonModalStep(state),
  data: selectUsisData(state),
  isModalOpened: selectIsModalOpened(state),
  isCommonModalOpened: selectIsCommonModalOpened(state),
  commonModalsData: selectCommonModalsData(state),
  isWaitingRequest: selectIsWaitingRequest(state),
  redirectToEsiaUrl: selectRedirectToEsiaUrl(state),
  isModalConfirmDeactivateOpened: selectIsModalConfirmDeactivateOpened(state),
  modalVariant: selectModalVariant(state),
});

export default connect(mapStateToProps)(ModalEsiaContainer);

ModalEsiaContainer.propTypes = {
  modalData: PropTypes.shape({}),
  step: PropTypes.string,
  commonStep: PropTypes.string,
  isModalOpened: PropTypes.bool,
  isCommonModalOpened: PropTypes.bool,
  commonModalsData: PropTypes.shape({}),
  isWaitingRequest: PropTypes.bool,
  redirectToEsiaUrl: PropTypes.string,
  modalVariant: PropTypes.string,
  isModalConfirmDeactivateOpened: PropTypes.bool,
};
